<template>
    <div id="contenedor-eliminar-contrato-sub-tema">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar Sub Tema </v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar el sub tema: {{contratoSubTemaEliminar.descripcion}}?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarSubTema"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import mixSubTemasContrato from './mixSubTemasContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarSubTemaContrato',
  mixins: [mixSubTemasContrato],
  props: {
    contratoSubTemaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style></style>
